import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const PredefinedModal = ({ show, onClose, onSaved, mode = 'create', message = null }) => {
  const [form, setForm] = useState({
    clientPhone: '',
    message: '',
    useAI: true,
    active: true,
    used: false,
  });

  const [clients, setClients] = useState([]);
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    fetchClients();
  }, []);

  useEffect(() => {
    if (mode === 'edit' && message) {
      setForm({
        clientPhone: message.clientPhone,
        message: message.message,
        useAI: message.useAI,
        active: message.active,
        used: message.used,
      });
    } else {
      setForm({
        clientPhone: '',
        message: '',
        useAI: true,
        active: true,
        used: false,
      });
    }
  }, [show, mode, message]);

  useEffect(() => {
    const match = clients.find(c => c.phone === form.clientPhone);
    setClientName(match ? match.name : '');
  }, [form.clientPhone, clients]);

  const fetchClients = async () => {
    try {
      const res = await axios.get(`${API_URL}/clients`);
      setClients(res.data);
    } catch (err) {
      console.error('Erro ao buscar clientes:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.clientPhone.trim() || !form.message.trim()) {
      alert('Client phone and message are required.');
      return;
    }

    try {
      if (mode === 'edit' && message?._id) {
        await axios.put(`${API_URL}/predefined/${message._id}`, {
          clientPhone: form.clientPhone,
          message: form.message,
          useAI: form.useAI,
          active: form.active,
        });
      } else {
        await axios.post(`${API_URL}/predefined`, {
          clientPhone: form.clientPhone,
          message: form.message,
          useAI: form.useAI,
        });
      }

      onSaved();
    } catch (err) {
      alert(err.response?.data?.error || 'Erro ao salvar mensagem.');
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg">
        <form onSubmit={handleSubmit}>
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h2 className="text-lg font-semibold">
              {mode === 'edit' ? 'Edit Message' : 'Add New Message'}
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 hover:text-gray-800 text-xl font-bold"
            >
              ×
            </button>
          </div>

          <div className="p-6 space-y-4">
            {form.used && mode === 'edit' && (
              <div className="text-sm text-yellow-600 bg-yellow-100 px-4 py-2 rounded">
                This message has already been used and cannot be edited.
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Client Phone</label>
              <input
                list="clientOptions"
                type="text"
                name="clientPhone"
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
                value={form.clientPhone}
                onChange={handleChange}
                disabled={form.used && mode === 'edit'}
              />
              <datalist id="clientOptions">
                {clients.map((client) => (
                  <option key={client._id} value={client.phone}>
                    {client.name} - {client.phone}
                  </option>
                ))}
              </datalist>
              {clientName && (
                <p className="text-sm text-gray-500 mt-1">Client: <strong>{clientName}</strong></p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
              <textarea
                name="message"
                rows="4"
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
                value={form.message}
                onChange={handleChange}
                disabled={form.used && mode === 'edit'}
              ></textarea>
            </div>

            <div className="flex items-center space-x-3">
              <label className="flex items-center text-sm">
                <input
                  type="checkbox"
                  name="useAI"
                  className="mr-2"
                  checked={form.useAI}
                  onChange={handleChange}
                  disabled={form.used && mode === 'edit'}
                />
                Use AI
              </label>

              {mode === 'edit' && (
                <label className="flex items-center text-sm">
                  <input
                    type="checkbox"
                    name="active"
                    className="mr-2"
                    checked={form.active}
                    onChange={handleChange}
                    disabled={form.used}
                  />
                  Active
                </label>
              )}
            </div>
          </div>

          <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded"
            >
              Cancel
            </button>
            {!form.used || mode === 'create' ? (
              <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
              >
                {mode === 'edit' ? 'Save Changes' : 'Add Message'}
              </button>
            ) : null}
          </div>
        </form>
      </div>
    </div>
  );
};

export default PredefinedModal;
